import React from "react";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Button from "@mui/material/Button";
import CardBody from "components/Card/CardBody.js";
import CardFooter from "components/Card/CardFooter.js";
import FormControl from "@mui/material/FormControl";
import TextField from "@mui/material/TextField";
import Autocomplete from "@material-ui/lab/Autocomplete";
import Snackbar from "components/Snackbar/Snackbar.js";
import AddAlert from "@material-ui/icons/AddAlert";
import PropTypes from "prop-types";
import Config from "conFig.js";
import { Error, Success } from "../../../assets/jss/util/messageUtil";
import { NumericFormat } from "react-number-format";

const Capnhatphuongtien = React.memo(function Capnhatphuongtien(props) {
  const { phuongtien_id } = props;
  const [loaihinhvantai, setLoaihinhvantai] = React.useState([]);
  const [donvi, setDonvi] = React.useState([]);
  const [loaihinhptvantaivalue, setLoaihinhptvantaivalue] = React.useState(
    null
  );
  const [donvivalue, setDonvivalue] = React.useState(null);
  const [sodangky, setSodangky] = React.useState("");
  const [taitrong, setTaitrong] = React.useState("");
  const [succhua, setSucchua] = React.useState("");
  const [alert, setAlert] = React.useState(false);
  const [message, setMessage] = React.useState("");
  const [alertValidate, setAlertValidate] = React.useState(false);
  const [messageValidate, setMessageValidate] = React.useState("");
  const token = localStorage.getItem("token");
  var username = localStorage.getItem("username");
  var obj = {
    method: "GET",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: "Bearer " + token,
    },
  };
  const getphuongtientheoid = () => {
    var url =
      Config.backend +
      "/api/Phuongtien/getphuongtienvantaitheoid?id=" +
      phuongtien_id +
      "&username=" +
      username;
    fetch(url, obj)
      .then((res) => res.json())
      .then((data) => {
        setSodangky(data[0].sodangky);
        setTaitrong(data[0].taitrong);
        setSucchua(data[0].succhua);
        setLoaihinhptvantaivalue({
          id: data[0].dmloaihinhptvantai_id,
          ten: data[0].dmloaihinhptvantai,
        });
        getdonvitheoloai(data[0].dmloaihinhptvantai_id);
        setDonvivalue({
          id: data[0].donvi_id,
          ten: data[0].donvi,
        });
      })
      .catch((error) => {
        console.error("Error fetching data: ", error);
      });
  };
  const getloaihinhvantai = () => {
    var url =
      Config.backend +
      "/api/Phuongtien/getdmloaihinhptvantaiall?username=" +
      username;
    fetch(url, obj)
      .then((res) => res.json())
      .then((data) => {
        setLoaihinhvantai(data);
      })
      .catch((error) => {
        console.error("Error fetching data: ", error);
      });
  };
  const getdonvitheoloai = (id) => {
    var url =
      Config.backend +
      "/api/donvi/getdvvttheoloaihinhpt?loaihinhptvantai_id=" +
      id +
      "&username=" +
      username;
    fetch(url, obj)
      .then((res) => res.json())
      .then((data) => {
        setDonvi(data);
      })
      .catch((error) => {
        console.error("Error fetching data: ", error);
      });
  };
  const capnhatphuongtien = () => {
    let mess = validateCapnhat();
    if (mess === Success.SC0001) {
      var url = Config.backend + "/api/Phuongtien/capnhatphuongtien";
      fetch(url, {
        method: "PUT",
        headers: {
          Accept: "application/json, text/plain",
          "Content-Type": "application/json;charset=UTF-8",
          Authorization: "Bearer " + token,
        },
        body: JSON.stringify({
          id: phuongtien_id,
          dvvt_id: donvivalue.id,
          sodangky: sodangky,
          dmloaihinhptvantai_id: loaihinhptvantaivalue.id,
          succhua: succhua,
          taitrong: taitrong,
          username: username,
        }),
      })
        .then((res) => res.json())
        .then((data) => {
          setMessage(data);
          showNotification();
        })
        .catch((error) => {
          console.error("Error fetching data: ", error);
        });
    } else {
      setMessageValidate(mess);
      showNotificationValidate();
    }
  };
  const showNotificationValidate = () => {
    setAlertValidate(true);
    setTimeout(function () {
      setAlertValidate(false);
    }, 6000);
  };
  const showNotification = () => {
    setAlert(true);
    setTimeout(function () {
      setAlert(false);
    }, 3000);
  };
  const validateCapnhat = () => {
    // Kiem tra cac truong bat buoc nhap
    if (sodangky.trim() === "") {
      return Error.ER0006;
    }
    if (!loaihinhptvantaivalue || loaihinhptvantaivalue.id === 0) {
      return Error.ER0007;
    }
    if (!donvivalue || donvivalue.id === 0) {
      return Error.ER0008;
    }
    return Success.SC0001;
  };
  React.useEffect(() => {
    getphuongtientheoid();
    getloaihinhvantai();
  }, []);
  return (
    <div>
      <CardBody style={{ borderBottom: "1px solid #bbb" }}>
        <GridContainer>
          <GridItem xs={12} sm={12} md={12}>
            <FormControl style={{ width: "100%", marginTop: "8px" }}>
              <TextField
                label="Số đăng ký"
                variant="outlined"
                size="small"
                value={sodangky}
                onChange={(event) => {
                  setSodangky(event.target.value);
                }}
                InputLabelProps={{
                  sx: {
                    color: "red",
                  },
                }}
                InputProps={{
                  style: {
                    height: "35px",
                  },
                }}
              />
            </FormControl>
          </GridItem>
          <GridItem xs={12} sm={12} md={12}>
            <FormControl style={{ width: "100%", marginTop: "8px" }}>
              <NumericFormat
                label="Tải trọng"
                variant="outlined"
                size="small"
                value={taitrong}
                customInput={TextField}
                allowNegative={false}
                thousandSeparator="."
                decimalSeparator=","
                decimalScale={0}
                onValueChange={({ value }) => {
                  setTaitrong(value);
                }}
                InputProps={{
                  style: {
                    height: "35px",
                  },
                }}
              />
            </FormControl>
          </GridItem>
          <GridItem xs={12} sm={12} md={12}>
            <FormControl style={{ width: "100%", marginTop: "8px" }}>
              <NumericFormat
                label="Sức chứa"
                variant="outlined"
                size="small"
                value={succhua}
                customInput={TextField}
                allowNegative={false}
                thousandSeparator="."
                decimalSeparator=","
                decimalScale={0}
                onValueChange={({ value }) => {
                  setSucchua(value);
                }}
                InputProps={{
                  style: {
                    height: "35px",
                  },
                }}
              />
            </FormControl>
          </GridItem>
          <GridItem xs={12} sm={12} md={12}>
            <FormControl style={{ width: "100%", marginTop: "8px" }}>
              <Autocomplete
                freeSolo
                disableClearable
                size="small"
                value={loaihinhptvantaivalue}
                getOptionSelected={(option, value) => option.id === value.id}
                options={loaihinhvantai}
                getOptionLabel={(option) => option.ten}
                onChange={(event, value) => {
                  setLoaihinhptvantaivalue(value);
                  setDonvivalue(null);
                  getdonvitheoloai(value.id);
                }}
                onInputChange={(event, newInputValue, reason) => {
                  if (reason !== "reset") {
                    setLoaihinhptvantaivalue(null);
                  }
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Loại hình phương tiện vận tải"
                    InputLabelProps={{
                      sx: {
                        color: "red",
                      },
                    }}
                    InputProps={{
                      ...params.InputProps,
                      type: "search",
                      style: {
                        height: "35px",
                        paddingTop: "initial",
                      },
                    }}
                  />
                )}
              />
            </FormControl>
          </GridItem>
          <GridItem xs={12} sm={12} md={12}>
            <FormControl style={{ width: "100%", marginTop: "8px" }}>
              <Autocomplete
                freeSolo
                disableClearable
                size="small"
                value={donvivalue}
                getOptionSelected={(option, value) => option.id === value.id}
                options={donvi}
                getOptionLabel={(option) => option.ten || ""}
                onChange={(event, value) => {
                  setDonvivalue(value);
                }}
                onInputChange={(event, newInputValue, reason) => {
                  if (reason !== "reset") {
                    setDonvivalue(null);
                  }
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Đơn vị"
                    InputLabelProps={{
                      sx: {
                        color: "red",
                      },
                    }}
                    InputProps={{
                      ...params.InputProps,
                      type: "search",
                      style: {
                        height: "35px",
                        paddingTop: "initial",
                      },
                    }}
                  />
                )}
              />
            </FormControl>
          </GridItem>
        </GridContainer>
      </CardBody>
      {/** fix css */}
      <CardFooter style={{ marginBottom: "20px" }}>
        <Button
          color="primary"
          variant="contained"
          style={{ height: 27 }}
          onClick={capnhatphuongtien}
        >
          Cập nhật
        </Button>
      </CardFooter>
      <GridContainer>
        <GridItem xs={12} sm={12} md={10} lg={8}>
          <Snackbar
            place="tc"
            color="warning"
            icon={AddAlert}
            message={message}
            open={alert}
            closeNotification={() => setAlert(false)}
            close
          />
        </GridItem>
        <GridItem xs={12} sm={12} md={10} lg={8}>
          <Snackbar
            place="tc"
            color="warning"
            icon={AddAlert}
            message={messageValidate}
            open={alertValidate}
            closeNotification={() => setAlertValidate(false)}
            close
          />
        </GridItem>
      </GridContainer>
    </div>
  );
});

Capnhatphuongtien.propTypes = {
  phuongtien_id: PropTypes.number,
};
export default Capnhatphuongtien;
